import React from 'react'

const AboutUsIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="currentColor"
      className={className}
      style={{ display: 'block' }}
    >
      {/* Document Outer Frame */}
      <path d="M56,63.43H8V.74H45.31L56,11.94ZM11.9,59.51H52.1v-46L43.64,4.66H11.9Z" />

      {/* Folded Corner Detail */}
      <polygon points="54.07 14.55 42.51 14.55 42.51 2.7 46.44 2.7 46.44 10.63 54.07 10.63 54.07 14.55" />

      {/* Person Silhouette - Shoulders/Body */}
      <path d="M31.06,44.17h1.87A11.18,11.18,0,0,1,44.11,55.34v6.13a0,0,0,0,1,0,0H19.89a0,0,0,0,1,0,0V55.34A11.18,11.18,0,0,1,31.06,44.17Z" />
      <path d="M44.6,62H19.4V55.13A11.45,11.45,0,0,1,30.85,43.68h2.3A11.45,11.45,0,0,1,44.6,55.13ZM20.38,61H43.62V55.13A10.47,10.47,0,0,0,33.15,44.66h-2.3A10.47,10.47,0,0,0,20.38,55.13Z" />

      {/* Person Silhouette - Head */}
      <rect x="26.42" y="26.96" width="10.07" height="10.07" rx="4.65" />
      <path d="M31.93,37.53H31a5.06,5.06,0,0,1-5-5.05v-1a5.06,5.06,0,0,1,5-5.05h1a5.06,5.06,0,0,1,5,5.05v1A5.06,5.06,0,0,1,31.93,37.53ZM31,27.45a4.07,4.07,0,0,0-4.06,4.07v1A4.07,4.07,0,0,0,31,36.55h1A4.08,4.08,0,0,0,36,32.48v-1a4.08,4.08,0,0,0-4.07-4.07Z" />
    </svg>
  )
}

export default AboutUsIcon
